<template>
  <article class="message is-info">
    <div class="message-header" @click="toggleSection()">
      <label>{{ section.title }} </label>
      <span class="icon is-small">
        <i :class="isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
      </span>
    </div>
    <div class="message-body" v-if="isOpen">
      <table class="table is-fullwidth is-striped is-hoverable">
        <tbody>
          <tr v-for="(value, key) in section.variables" :key="key">
            <td><strong>{{ key }}</strong></td>
            <td>{{ value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </article>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'DocumentosContractuales',
  mixins: [mixins],
  components: {
    // Paginator: () => import('@/components/ui/BasePagination')
  },
  props: {
    section: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isLoading: false,
      isOpen: true
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany
    })
  },
  async mounted () {},
  methods: {
    ...mapActions([]),
    toggleSection () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.message-header {
  background-color: #f4f4f4;
  font-size: 12px;
  padding: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.message-body {
  padding: 0.5rem 0px;
  font-size: 10px;
  background: #fff;
}
</style>
